<script lang="ts" setup>
    import type { ITrendingJobCategory } from '@/types/LP/trendingjob';
    interface IProps {
        data: ITrendingJobCategory
    }
    const props = defineProps<IProps>()
    const fallbackImage = '/images/avatar.png'
</script>

<template>
    <div class="card-trending-job">
        <div class="card-trending-job__image-container">
            <img 
                :src="props.data.icon_url || fallbackImage" 
                :alt="props.data.name" 
                class="card-trending-job__image ratio-item"
            >
        </div>
        <div class="card-trending-job__info">
            <h3 class="card-trending-job__title">
                {{ props.data.name }}
            </h3>
            <div class="card-trending-job__description">
                {{ props.data.description }}
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.card-trending-job {
  
    background: #FFFFFF;
    @include imageRatio(48 48, 42 42, true,contain);
    @include vwUnit('border-radius', 10.67, 8);
    @include vwUnit('padding', 18 26, 14 20);
    @include vwUnit('gap', 10,8);
    overflow: hidden;
    height: 100%;
    display: flex;
    gap: 16px;
    align-items: center;
    border: 1px solid #0000001A;
    transition: all 0.4s ease;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
        border-color: #FF1D25;
        cursor: pointer;
    }

    &:hover &__image {
        transform: scale(1.05);
    }

    &__info {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    &__title {
        font-family: $primary-font;
        color: #2E263DE5;
        font-weight: 600;
        line-height: 1.3;
        @include vwUnit('font-size', 20, 18);
        @include vwUnit('margin-bottom', 4, 4);
        letter-spacing: -0.02em;

        @media only screen and (max-width: 1399.98px) {
            font-size: 18px;
        }
    }

    &__image-container{
        overflow: hidden;
        border-radius: 100%;
    }

    &__image{
        transition: 0.4s ease;
    }

    &__description {
        font-family: $primary-font-light;
        color: #404040;
        font-weight: 400;
        line-height: 1.4;
        @include vwUnit('font-size', 16, 16);
        @media only screen and (max-width: 1399.98px) {
            font-size: 16px;
        }
    }
}
</style>
